import { h } from 'preact';
import { SectionHeader } from '../SectionHeader';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'SectionHeader',
  category: '🗂️ Navegação',
  description: 'Cabeçalho de seção com título, subtítulo e ação',
  usedIn: ['AgentesPage', 'Integrations', 'ReferralDashboard'],
  example: () => (
    <SectionHeader title="Título da Seção" subtitle="Subtítulo descritivo" action={<Button size="sm">Ação</Button>} />
  ),
};
